export default __webpack_public_path__ + "static/media/guide_044.a58de919.md";